<template>
  <div class="extensionInvitationBox">
    <div class="main">
      <div class="envelope">
        <div class="info">
          <img :src="info.headerimg" alt />
          <p>
            <span>{{ info.nickname }}</span> · 给你发来一个邀请
          </p>
        </div>
        <h5>邀请你一起成为</h5>
        <h5>艺术教育推广大使</h5>
      </div>
      <button @click="acceptInvitation()">接受邀请</button>
      <div class="logo">
        <img src="@/assets/img/h5/logo2.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "推广员邀请",
    };
  },
  name: "extensionInvitation",
  data() {
    return {
      info: "",
      customercode: "",
    };
  },
  mounted() {
    this.customercode = this.$route.query.customercode;
    this.ShareCustdistributionInfo();
  },
  methods: {
    ShareCustdistributionInfo() {
      var obj = {
        sharecode: this.customercode, //分享的 customercode 值
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByShareCustdistributionInfo",
        obj
      ).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            this.info = res.data.customer;
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
    acceptInvitation() {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return;
      } else {
        this.Custdistribution();
      }
    },

    // 接受邀请
    Custdistribution() {
      var obj = {
        promoterid: this.info.customerid, //推广员ID
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/createByInvitationCustdistribution",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.$router.push({
              path: "/h5/mine/promote/promote",
            });
          } else if (res.data.rtncode == 60111) {
            this.$router.push({
              path: "/h5/mine/promote/promote",
            });
            this.util.toast({ msg: res.data.rtnmsg });
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.extensionInvitationBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, #d9d9e3, #ebeeed);
  .main {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .envelope {
      margin-top: 119px;
      width: 375px;
      height: 340px;
      background: url(../../../../assets/img/h5/envelope.png) no-repeat;
      background-size: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .info {
        margin-top: 43px;
        text-align: center;
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
        p {
          font-size: 12px;
          line-height: 17px;
          color: #86878a;
          margin: 8px 16px;
        }
      }
      h5 {
        font-size: 22px;
        font-weight: bold;
        line-height: 33px;
        color: #35363c;
      }
    }
    button {
      padding: 14px 52px;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      background: #c9373d;
      color: #ffffff;
      border-radius: 3px;
      box-shadow: 2px 2px 6px 0 rgba(201, 55, 61, 0.3);
    }
    .logo {
      margin-top: 80px;
      width: 102px;
      height: 33px;
    }
  }
}
</style>